import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TextListComponent } from '../../db-text/text-list/text-list.component';
import { UcrTextModule } from '../../db-text/ucr-text.module';
import { UcrFormsModule } from '../../forms/ucrforms.module';
import { SharedModule } from '../../shared/shared.module';
import { TablesModule } from '../../tables/tables.module';
import { EmailTemplateModule } from '../email-template/email-template.module';
import { FormConfigurationEditComponent } from './form-configuration-edit/form-configuration-edit.component';
import { FormConfigurationComponent } from './form-configuration.component';
import { OwnerEditComponent } from './owners/owner-edit/owner-edit.component';
import { OwnerService } from './owners/owner.service';
import { OwnersComponent } from './owners/owners.component';

@NgModule({
    declarations: [
        FormConfigurationComponent,
        FormConfigurationEditComponent,
        TextListComponent,
        OwnersComponent,
        OwnerEditComponent
    ],
    exports: [FormConfigurationComponent, TextListComponent],
    imports: [
        CommonModule,
        MatIconModule,
        MatPaginatorModule,
        MatTableModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatButtonModule,
        MatInputModule,
        MatTooltipModule,
        MatSortModule,
        MatCheckboxModule,
        MatSelectModule,
        SharedModule,
        MatTabsModule,
        MatProgressBarModule,
        UcrFormsModule,
        UcrTextModule,
        EmailTemplateModule,
        TablesModule
    ],
    providers: [OwnerService]
})
export class FormConfigurationModule {}
